// extracted by mini-css-extract-plugin
module.exports = {"results":"browse_results__cnoj5","loading":"browse_loading__NU48A"};